import {
  Button,
  Card,
  DevicePhoneMobileIcon,
  ErrorAlert,
  Input,
  danger,
  success,
  useCustomForm,
  useFetchData,
} from "@";
import IntegrationShell from "../shared/IntegrationShell";
import { getSmsSettings, saveSmsSettings } from "../shared/api";
import { defaultValues, schema } from "./utils/validation";

const PROVIDERS = [
  {
    key: "oursms",
    name: "OurSMS",
    description: "خدمة الرسائل القصيرة الأشهر محلياً مع تغطية شاملة.",
  },
];

const Index = () => {
  const {
    reset,
    watch,
    errors,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues, schema);

  const { error, fetchData } = useFetchData({
    reset,
    fun: getSmsSettings,
  });

  const provider = watch("provider");

  const submit = async (data) => {
    try {
      await saveSmsSettings(data);
      success("تم حفظ إعدادات مزوّد الرسائل القصيرة");
    } catch (err) {
      danger("تعذّر حفظ الإعدادات. تحقق من القيم وحاول مجدداً.");
    }
  };

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />

      <IntegrationShell
        eyebrow="الإعدادات / التكاملات"
        title="مزوّدو الرسائل القصيرة"
        icon={DevicePhoneMobileIcon}
        breadcrumbName="مزوّدو الرسائل القصيرة"
        providers={PROVIDERS}
        active={provider}
        onActiveChange={(key) => setValue("provider", key)}
        isSaving={isSubmitting}
      >
        <form onSubmit={handleSubmit(submit)} className="mt-2">
          {provider === "oursms" && (
            <Card title="إعدادات OurSMS">
              <div className="grid gap-5 md:grid-cols-2">
                <Input
                  star
                  label="اسم المستخدم"
                  placeholder="اسم المستخدم في OurSMS"
                  error={errors.oursmsUsername}
                  input={register("oursmsUsername")}
                />
                <Input
                  star
                  type="password"
                  label="كلمة المرور"
                  placeholder="••••••••"
                  error={errors.oursmsPassword}
                  input={register("oursmsPassword")}
                />
                <div className="md:col-span-2">
                  <Input
                    star
                    label="اسم المُرسِل (Sender Name)"
                    placeholder="مثال: KHZAMA"
                    error={errors.oursmsSenderName}
                    input={register("oursmsSenderName")}
                  />
                </div>
              </div>
            </Card>
          )}

          <div className="mt-5 flex items-center justify-end gap-3">
            <p className="hidden text-xs text-gray-500 dark:text-gray-400 sm:block">
              سيُستخدم المزوّد المختار لإرسال كل الرسائل النصية.
            </p>
            <Button
              type="submit"
              title="حفظ الإعدادات"
              isLoading={isSubmitting}
            />
          </div>
        </form>
      </IntegrationShell>
    </>
  );
};

export default Index;
